import { Pipe, PipeTransform } from '@angular/core';
import { Batch } from '../../models';
import { PRINTED, CLOSED, SEALED_PRINTING, PREPRINT, PRINTING } from '../../../ngrx/status-types';

/**
 * Active Batch pipe
 * Takes a list of batches as an argument and filters out inactive batches
 * e.g. Batches containing no jobs
 * 
 * Usage: batches | activeBatch
 */

@Pipe({
  name: 'activeBatch'
})
export class ActiveBatchPipe implements PipeTransform {
  transform(batches: Batch[], isOA) {
    if(isOA) {
      return batches.filter(batch => batch.batchStatus !== PREPRINT && batch.batchStatus !== SEALED_PRINTING && batch.batchStatus !== PRINTING);
    } else {
      return batches.filter(batch => batch.batchStatus !== CLOSED && batch.batchStatus !== PRINTED && batch.numberOfJobs >= 1);
    }
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/active-batch.pipe.ts